import { ImageOrientation } from '@space-core/components/customImage/enum'

import styled from 'styled-components'

import type { CardProps } from './types'

import MobileBaseCard from '../base/mobile'

const Title = styled.h3`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-break: auto;
`

const Description = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-break: auto;
`

const ProductCardMobileDefault = ({
  product,
  containerOrientation,
  imageOrientation
}: CardProps) => {
  return (
    <MobileBaseCard
      avatar={product.avatar}
      avatarAltText={product.avatarAltText}
      thumbnailImage={product.thumbnailImage}
      coverImage={product.coverImage}
      imageAlt={product.altText}
      verticalCoverPage={product.verticalCoverPage}
      verticalAltText={product.verticalAltText}
      freeSignup={product.freeSignup}
      containerOrientation={containerOrientation}
      imageOrientation={imageOrientation}>
      {imageOrientation === ImageOrientation.HORIZONTAL && (
        <>
          <p className='_text-1 _text-gray-900 _text-left _mb-1'>{product.category}</p>

          <Title className='_text-2 _text-gray-900 _font-weight-bold _text-left _mb-1 _pt-1 _pb-0'>
            {product.name}
          </Title>

          <Description className='_font-14 _mb-1 _text-gray-600 _text-left _w-full'>
            {product.description}
          </Description>

          {Boolean(product.price) && !product.isPurchased && (
            <p className='_m-0 _font-weight-bold _text-green'>{product.price}</p>
          )}
        </>
      )}
    </MobileBaseCard>
  )
}

export default ProductCardMobileDefault
